<template>

    <v-card>
        <v-card-title>Report Notes</v-card-title>
        <v-divider />


        <v-card-text class="mt-4">

            <div id="report-notes-ckeditor-container">
                <div id="report-notes-ckeditor" />
            </div>
            
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer />
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>
    </v-card>
    
</template>

<script>
export default {
    name: 'ReportNotes',
    props: ['notes'],
    components: {

    },
    data: () => ({
        reportNotesContent: null,
        toolbarWrapperElement: null,
        toolbarElement: null,
        saveButton: null,

        editorConfig: {
            toolbar: {
                shouldNotGroupWhenFull: true,
                items: [
                    'heading',
                    '|',
                    'alignment',
                    '|',
                    'fontFamily',
                    'fontSize',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'link',
                    '|',
                    'bulletedList',
                    'numberedList',
                    'todoList',
                    '|',
                    'indent',
                    'outdent',
                    '|',
                    'imageUpload',
                    'blockQuote',
                    'insertTable',
                    'mediaEmbed',
                    'undo',
                    'redo'
                ]
            },
            language: 'en',
            fontSize: {
                options: [9,11,12,14,16,18,24,32,36,48,72]
            },
            image: {
                toolbar: [
                    'imageTextAlternative',
                    'imageStyle:full',
                    'imageStyle:side'
                ]
            },
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells',
                    'tableCellProperties',
                    'tableProperties'
                ]
            },
            mediaEmbed: {
                previewsInData: true,
                toolbar: [
                    'undo',
                    'fontSize'
                ]
            },
            licenseKey: ''
        },
    }),

    computed: {

    },

    methods: {
        initializeEditor() {
            ClassicEditor.create(document.getElementById('report-notes-ckeditor'), this.editorConfig).then(editor => {
                this.toolbarWrapperElement = document.querySelectorAll('#report-notes-ckeditor-container .ck .ck-sticky-panel')[0];
                this.toolbarElement = document.querySelectorAll('#report-notes-ckeditor-container div.ck.ck-sticky-panel__content .ck .ck-toolbar__items')[0];

                this.editorObj = editor;
                this.editorObj.isReadOnly = false;
                this.editorObj.setData(this.reportNotesContent);

                this.createToolbarSeparator();
                this.createSaveButton();
            });
        },

        createToolbarSeparator() {
            let separator = document.createElement('div');
            separator.innerHTML = `<span class="ck ck-toolbar__separator"></span>`;
            separator = separator.firstElementChild;
            this.toolbarElement.appendChild(separator);
        },

        createSaveButton() {
            this.saveButton = document.createElement('div');
            this.saveButton.innerHTML = `<button id="" class="ck ck-button ck-off" type="button" tabindex="-1" aria-labelledby="ck-editor__aria-label_e165209a029a9b7541e118f7bc50983cd" aria-pressed="false">
                    <svg class="ck ck-icon ck-button__icon" viewBox="0 0 20 20">
                        <path fill="#c42111" d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"></path>
                    </svg>
                    <span class="ck ck-tooltip ck-tooltip_s">
                        <span class="ck ck-tooltip__text">Save Content</span>
                    </span>
                    <span class="ck ck-button__label" id="ck-editor__aria-label_e165209a029a9b7541e118f7bc50983cd">Save Content</span>
                </button>`;
            this.saveButton = this.saveButton.firstElementChild;
            this.saveButton.addEventListener("click", this.savePageContentClick);
            this.toolbarElement.appendChild(this.saveButton);
        },

        savePageContentClick() {
            console.log('savePageContentClick');
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to overwrite these report notes?',
                type: 'warning',
                confirmAction: () => {this.savePageContent();}
            });
        },
        savePageContent() {
            let content = this.editorObj.getData();
            console.log('NOW savePageContent: ', content);
            TELSA.loading(true);
            let route = `${TELSA.apiHost}report/notes`;
            return this.$http.post(route, {args: {report_name: this.$props.notes.user_obj_name, report_notes_content: content}}).then(response => {
                let result = response.body;
                this.$props.notes.obj_notes = content;
                TELSA.loading(false);
            });
        }

    },

    mounted() {
        this.reportNotesContent = this.$props.notes ? this.$props.notes.obj_notes : "";
        this.initializeEditor();
    }

};
</script>

<style>
    
    #report-notes-ckeditor-container .ck-editor[role='application'] .ck.ck-content {
        color: #000000;
        background-color: #ffffff;
        height: calc(100vh - 500px);
        border-top: #000000 solid 1px;
        border-right: gray solid 1px;
        border-bottom: gray solid 1px;
        border-left: gray solid 1px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

</style>
